<template>
  <pt-coupon-detail class="pt-coupon-detail__page" :id="id"></pt-coupon-detail>
</template>

<script>
import PtCouponDetail from 'cps/mall-manage/pt-coupon-review/pt-coupon-detail/withData'
export default {
  name: 'pt-coupon-detail__view',
  components: {
    'pt-coupon-detail': PtCouponDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
